import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Services } from "@/components/landing/Services";
import { Gallery } from "@/components/landing/Gallery";
import { Values } from "@/components/landing/Values";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppButton } from "@/components/landing/WhatsAppButton";

function App() {
  return (
    <div className="App bg-[#0A0A0A] min-h-screen text-white antialiased selection:bg-[#FF1616] selection:text-black">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Values />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-right" richColors theme="dark" />
    </div>
  );
}

export default App;
